<div class="titulo" style="margin: 0 auto;text-align: center;margin-top: 20px;">

    <h3>Lista de Usuarios</h3>
<hr>
</div>

<!-- <div>
    <button type="button" class="btn btn-success" data-toggle="modal" data-target="#exampleModal" title="Agregar usuario"><i class="mdi mdi-account-plus" aria-hidden="true"></i></button>
</div> -->


<div class="mt-2" >

    <table id="empleados" datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="table" style="width: 100%;">
        <thead>
            <tr style="color:#000">
                <!-- <th style="text-align:center;width:80px">Id</th> -->
                <th style="text-align:center;width:100px">Núm. Empleado</th>
                <th style="text-align:center;width:80px">Usuario</th>
                <th style="text-align:center;width: 250px;">Nombre</th>
                <th style="text-align:center;width: 150px;">Área</th>
                <th style="text-align:center;width: 150px;">Activo</th>
   
            </tr>
        </thead>
        <tbody style="font-size: 15px;">
            <tr *ngFor="let usuario of usuarios">
                <!-- <td style="text-align:center;">{{ usuario.id_usuario }}</td> -->
                <td style="text-align:center;">{{ usuario.numempleado }}</td>
                <td style="text-align:center;">{{ usuario.usuario}}</td>
                <td style="text-align:center;">{{ usuario.nombre}}</td>
                <td style="text-align:center;">{{ usuario.nombrearea}}</td>
                <td style="text-align:center;">{{ usuario.activo ? 'Si' : 'No'}}</td>
                
            </tr>
        </tbody>
    </table>
</div>


<!-- Modal -->
<div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">Agregar usuario</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">


         

          <form (ngSubmit)="AgregarUsuario()">

            <div class="form-row">

                <div class="form-group col-md-7">
                    <label for="inputAddress">Nombre</label>
                    <input [(ngModel)]="nuevo_usuario.nombre" type="text" class="form-control" name="contraseña" placeholder="">
                  </div>

                  <div class="form-group col-md-5">
                    <label for="inputAddress">Usuario</label>
                    <input [(ngModel)]="nuevo_usuario.usuario" type="text" class="form-control" name="usuario" placeholder="">
                  </div>

            </div>


            <div class="form-row">

              <div class="form-group col-md-7">
                  <label for="inputAddress">Contraseña</label>
                  <input [(ngModel)]="nuevo_usuario.password" type="password" class="form-control" name="contraseña" placeholder="">
                </div>

                <div class="form-group col-md-5">
                  <label for="inputAddress">Núm. empleado</label>
                  <input [(ngModel)]="nuevo_usuario.numempleado" type="text" class="form-control" name="numempleado" placeholder="">
                </div>

            </div>


            <div class="form-row">

              <div class="form-group col-md-7">
                  <label for="inputAddress">Área</label>
                  <input [(ngModel)]="nuevo_usuario.area" type="text " class="form-control" name="Area" placeholder="" readonly>
                </div>
              </div>
          
   
        <div class="modal-footer">
          <button type="submit" class="btn btn-success">Dar de alta</button>
        </div>

      </form>

    </div>

      </div>
    </div>
  </div>